import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BiRelatorioTaxaService extends ServiceCRUD {
  private baseUrlService: string;

  constructor(public httpClient: HttpClient, router: Router) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
    })
  };

  protected getURL(): string {
    return '';
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealer?: any,
    grupo_economico?: any,
    numeroOS?: any,
    codItem?: any,
    classificacao?: any,
    filter?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/relatorio_taxa'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealer', dealer.toString())
        .set('grupo_economico', grupo_economico.toString())
        .set('numeroOS', numeroOS.toString())
        .set('codItem', codItem.toString())
        .set('classificacao', classificacao !== null ? classificacao.toString() : null)
    });
  }

  public getDadosAnaliticos(
    codigo?: any,
    data_inicial?: any,
    data_final?: any,
    grupo_economico?: any,
    numeroOS?: any,
    codItem?: any,
    classificacao?: any,
    filter?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/relatorio_taxa/itens/' + codigo.toString()}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('grupo_economico', grupo_economico.toString())
        .set('numeroOS', numeroOS.toString())
        .set('codItem', codItem.toString())
        .set('classificacao', classificacao !== null ? classificacao.toString() : null)
    });
  }

}
